import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Meters.css';
import './BusBars.css';
import click from './sounds/shortclick.mp3';
import switchboard from './images/WaterLeakageMainSwitchBoardWLS.jpg';

const BoardWidth = 1800;

// A custom component that displays an image
function SwitchBoardImage(props) {
    return (
        <div className="estate-image" align-items="center">
            < img src={props.src} alt={props.alt} width={BoardWidth} />
        </div>
    );
}

export default function BusBars() {

    //const [dev, setDev] = useState([]);
    //const [displaydev, setDisplsyDev] = useState([]);
    const [retry, setRetry] = useState(false);
    const [hoveredCell, setHoveredCell] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    //const [buildingId, setBuildingId] = useState(1);
    //const [switchBoardImage, setSwitchBoardImage] = useState(switchboard);

    const [pins, setPins] = useState([]);

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    // Handle button click
    /*function handleClick(e) {
        console.log("Button clicked with value:", e); // Add this line
        playClickSound();
        setBuildingId(e);
        let scaledPin_2 = dev
            .filter(device => device.id > 266 && device.id < 323)
            .filter(device => device.mapx !== null && device.mapy !== null)
            .filter(device => device.buildingId === e)
            .map(device => {
                return { ...device, x: device.mapx, y: device.mapy };
            });
        // Set the pins state with the coordinates
        setPins(scaledPin_2);
        switch (e) {
            case 1:
                setSwitchBoardImage(switchboard_yfh);
                break;

            case 2:
                setSwitchBoardImage(switchboard_ych);
                break;

            case 3:
                setSwitchBoardImage(switchboard_ro);
                break;

            default:
                break;
        }
        let filteredDev = dev.filter(d => d.channel === e);
        setDisplsyDev(filteredDev);
    };*/


    const PinIcon = ({ x, y, info, delay }) => {
        const [isHovered, setIsHovered] = useState(false);
        const [isDropped, setIsDropped] = useState(false);

        useEffect(() => {
            // Trigger the drop animation after the specified delay
            const timer = setTimeout(() => {
                setIsDropped(true);
            }, delay);

            return () => clearTimeout(timer);
        }, [delay]);

        return (
            <div
                style={{
                    position: "absolute",
                    left: `${x}px`,
                    top: isDropped ? `${y}px` : "-50px",
                    transform: "translate(-50%, -50%)",
                    zIndex: 5,
                    pointerEvents: "auto",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    transition: `top 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${delay}ms`,
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {/* Pin dot */}
                <div style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: isHovered ? "#ff0000" : "#ff5252",
                    border: "2px solid white",
                    boxShadow: "0 0 0 2px rgba(255,0,0,0.5)",
                    transition: "all 0.2s ease",
                    transform: isHovered ? "scale(1.3)" : "scale(1)",
                }} />

                {/* Tooltip positioned to the right */}
                <div style={{
                    position: "relative",
                    backgroundColor: "rgba(0, 0, 255, 1)",
                    borderRadius: "4px",
                    padding: isHovered ? "6px 10px" : "2px 6px",
                    fontSize: isHovered ? "28px" : "14px",
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    whiteSpace: "nowrap",
                    transition: "all 0.2s ease",
                    opacity: isHovered ? 1 : 1,
                    transform: isHovered ? "translateX(0)" : "translateX(5px)",
                    marginLeft: "8px", // Space between pin and tooltip
                }}>
                    {info}
                    {/* Tooltip arrow pointing left */}
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "-6px",
                        transform: "translateY(-50%)",
                        width: 0,
                        height: 0,
                        borderTop: "6px solid transparent",
                        borderBottom: "6px solid transparent",
                        borderRight: "6px solid rgba(0, 0, 255, 1)",
                    }} />
                </div>
            </div>
        );
    }
    const ImageWithPins = ({ pins }) => {
        return (
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none", // ← Disable pointer events on container
            }}>
                {pins.map((pin, index) => {
                    // Safely parse and check if data is a valid number
                    const numValue = parseFloat(pin.data);
                    const isValidNumber = !Number.isNaN(numValue) && pin.data !== null;

                    return (
                        <PinIcon
                            key={index}
                            x={pin.x + 12}
                            y={pin.y + 36}
                            info={`${pin.label}: ${isValidNumber ? numValue.toFixed(1) : 'N/A'}°C`}
                            delay={index * 30 + 1000}
                        />
                    );
                })}
            </div>
        );
    };

    useEffect(() => {

        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Call the web API endpoint with GET method
        const getData = async () => {
            setIsLoading(true);
            await httpClient.get('/api/meters')
                .then((response) => {
                    const deviceDetails = response.data.map((item) => ({
                        id: item.deviceId,
                        deviceName: item.deviceName,
                        deviceEui: item.deviceEui,
                        label: item.label,
                        status: item.status,
                        mapx: item.mapx === null ? null : item.mapx ,
                        mapy: item.mapy === null ? null : item.mapy ,
                        logic: item.type,
                        data_type: item.dataType,
                        alive: item.alive,
                        data: item.data,
                        channel: item.channel,
                        unit: item.unit,
                        modbusId: item.modbusId,
                        //buildingId: item.buildingId
                    }));

                    let scaledPin_2 = deviceDetails
                        .filter(device => device.id > 120 && device.id < 145)
                        .filter(device => device.mapx !== null && device.mapy !== null)
                        //.filter(device => device.buildingId === buildingId)
                        .map(device => {
                            return { ...device, x: device.mapx, y: device.mapy };
                        });
                    console.log("ScaledPin2");
                    console.log(scaledPin_2);
                    // Set the pins state with the coordinates
                    setPins(scaledPin_2);

                    //let filteredDev = deviceDetails.filter(d => (d.modbusId > 99) && (d.modbusId < 124));

                    //setDisplsyDev(filteredDev);
                    //setDev(deviceDetails);

                    console.log("Displadev");
                    console.log(response);
                    setIsLoading(false);
                })
                .catch(error => {

                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });
        };

        getData();

    }, [retry]);

    function DList() {

        return (
            <div>
                <tr className="row">
                    <td style={{ verticalAlign: "top", width: "572px" }}>
                        <table style={{ verticalAlign: "top" }} >
                            <tr>
                                {!isLoading && (
                                    //<div className="boardpin" >
                                    <div style={{ position: "relative", display: "inline-block" }}> 
                                        <SwitchBoardImage
                                            src={switchboard}
                                        />
                                        <ImageWithPins pins={pins} />
                                    </div>
                                )}
                            </tr>
                        </table>
                    </td>
                </tr>
            </div>
        );

    };

    return (
        <div className="containerstyle">
            <table>
                <td >

                    <div >
                        <table>
                            <tr>
                                <td style={{ verticalAlign: "top" }}>
                                    <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1680px" }}>

                                        <DList />

                                    </table>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </table>
        </div>
    );


}
